import { cn } from "lib/utils";
import { forwardRef, type InputHTMLAttributes } from "react";

export type DateTimeInputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "className" | "type"
>;

/**
 * 純粋な DateTime 入力リーフ。`<input type="datetime-local">`。
 * @param {DateTimeInputProps} props DateTimeInput の props
 * @return {JSX.Element} DateTimeInput 要素
 */
export const DateTimeInput = forwardRef<HTMLInputElement, DateTimeInputProps>(
  (props, ref) => {
    return (
      <input
        ref={ref}
        type="datetime-local"
        className={cn("input input-bordered input-sm w-full")}
        {...props}
      />
    );
  },
);
DateTimeInput.displayName = "DateTimeInput";
